import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["referenceableId"]

  connect() {
    // Initialize the controller
  }

  updateReferenceableId(event) {
    const selectedType = event.target.value
    const referenceableIdSelect = this.element.closest('form').querySelector('select[name="service_request_master[referenceable_id]"]')
    
    if (referenceableIdSelect && selectedType) {
      // Fetch available references based on selected type
      fetch(`/api/${selectedType.toLowerCase()}s`)
        .then(response => response.json())
        .then(data => {
          // Clear and update options
          referenceableIdSelect.innerHTML = '<option value="">Select reference</option>'
          data.forEach(item => {
            const option = new Option(item.name || `#${item.id}`, item.id)
            referenceableIdSelect.add(option)
          })
        })
        .catch(error => {
          console.error('Error fetching references:', error)
        })
    } else if (referenceableIdSelect) {
      // Clear options if no type selected
      referenceableIdSelect.innerHTML = '<option value="">Select reference</option>'
    }
  }
} 